<template>
  <div class="child-route-wrapper company-info-wrapper">
    <h1 class="registration-form-title">
      Company information
    </h1>
    <validation-observer
      #default="{ validate }"
      class="observer-wrapper"
    >
      <b-form
        class="registration-form-wrapper"
        @submit.prevent="onSubmit(validate)"
      >
        <validation-provider
          #default="{ errors, valid }"
          name="Company name"
          :rules="stepData[AUTH_REGISTER_V2_CHILDREN.COMPANY_INFO].fields.companyName"
        >
          <b-form-group
            class="registration-input-group extra-margin"
            label="Company name"
            label-class="registration-label"
          >
            <b-form-input
              v-model="companyName"
              class="registration-input"
              :class="{ 'is-invalid': errors.length }"
              :state="valid || companyName === '' ? null : false"
              type="text"
              placeholder="Company name"
            />
            <div class="input-error">
              <small class="text-danger">{{ errors[0] }}</small>
            </div>
          </b-form-group>
        </validation-provider>
        <b-form-group
          class="registration-input-group extra-margin"
          label="Company role"
          label-class="registration-label"
        >
          <b-form-input
            v-model="companyRole"
            class="registration-input"
            type="text"
            placeholder="Company role"
          />
        </b-form-group>
        <b-button
          class="registration-button"
          type="submit"
        >
          Next
        </b-button>
      </b-form>
    </validation-observer>
  </div>
</template>
<script>
import {
  BForm, BFormGroup, BFormInput, BButton,
} from 'bootstrap-vue'
import { useFormFields } from '@/views/apps/authentication-v2/useFormFields'
import { AUTH_REGISTER_V2_CHILDREN } from '@/router/routes/utils'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import constants from '@/constants'
import analytics from '@/@core/utils/analytics'
import { debounce } from 'lodash'
import { watch } from '@vue/composition-api'
import { stepData } from './verifySteps'

export default {
  name: 'CompanyInfo',
  components: {
    BForm,
    BFormGroup,
    BFormInput,
    BButton,
    ValidationObserver,
    ValidationProvider,
  },
  data() {
    return {
      AUTH_REGISTER_V2_CHILDREN,
      stepData,
    }
  },
  mounted() {
    analytics.track(constants.TRACKS.ACTIONS.REGISTER_V2.COMPANY_INFO_VIEW)
  },
  setup() {
    const {
      companyName,
      companyRole,
    } = useFormFields()

    const trackInputFields = debounce((newCompanyName, newCompanyRole) => {
      analytics.track(constants.TRACKS.ACTIONS.REGISTER_V2.COMPANY_INFO_ENTERS_DATA, {
        formData: {
          companyName: newCompanyName,
          companyRole: newCompanyRole,
        },
      })
    }, 1000)

    watch(
      [companyName, companyRole],
      ([newCompanyName, newCompanyRole]) => {
        trackInputFields(newCompanyName, newCompanyRole)
      },
    )
    return {
      companyName,
      companyRole,
    }
  },
  methods: {
    async onSubmit(validate) {
      const areFieldsValid = await validate()
      if (areFieldsValid) {
        analytics.track(constants.TRACKS.ACTIONS.REGISTER_V2.COMPANY_INFO_NEXT_CLICK, {
          formData: {
            companyName: this.companyName,
            companyRole: this.companyRole,
          },
        })
        this.$router.push({ name: AUTH_REGISTER_V2_CHILDREN.CHOOSE_USER_TYPE })
      }
    },
  },
}
</script>
<style lang="scss">
@import '../common-styles.scss';
.company-info-wrapper {
  @media (max-height: 820px) {
    height: fit-content;
  }
}

.observer-wrapper {
  width: 100%;
}

.phone-row {
  display: flex;
  gap: 16px;
}

.country-code {
  min-width: 110px;
}

.phone-number {
  width: calc(100% - 110px);
}

.extra-margin {
  margin-bottom: 10px;
}
</style>
